import { useState } from 'react';
import GreenButton from '../Components/Buttons/Greenbutton';
import Icon from '../Components/Icons/Icon';
import { createContactMessage } from '../lib/api';

function ContactPage() {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notice, setNotice] = useState('');
  const [error, setError] = useState('');

  function updateField(field, value) {
    setForm((current) => ({ ...current, [field]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);
    setNotice('');
    setError('');

    try {
      await createContactMessage(form);
      setNotice('Your message has been sent.');
      setForm({
        fullName: '',
        email: '',
        phone: '',
        message: '',
      });
    } catch (submitError) {
      setError(submitError.message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <section className="page-card contact-page">
      <h1 className="page-card__title">Contact Us</h1>
      <p className="page-card__text">
        Have a question about frames, lenses, or appointments? Send us a message
        and we&apos;ll get back to you soon.
      </p>
      <div className="contact-page__grid">
        <form className="account-form contact-page__form" onSubmit={handleSubmit}>
          <div className="account-form__row">
            <label className="auth-form__field">
              <span>Full Name</span>
              <input
                required
                type="text"
                value={form.fullName}
                onChange={(event) => updateField('fullName', event.target.value)}
              />
            </label>
            <label className="auth-form__field">
              <span>Phone</span>
              <input
                required
                type="text"
                value={form.phone}
                onChange={(event) => updateField('phone', event.target.value)}
              />
            </label>
          </div>
          <label className="auth-form__field">
            <span>Email</span>
            <input
              required
              type="email"
              value={form.email}
              onChange={(event) => updateField('email', event.target.value)}
            />
          </label>
          <label className="auth-form__field">
            <span>Message</span>
            <textarea
              required
              rows="5"
              value={form.message}
              onChange={(event) => updateField('message', event.target.value)}
            />
          </label>
          {notice ? <p className="orders-success">{notice}</p> : null}
          {error ? <p className="products-state products-state--error">{error}</p> : null}
          <div className="contact-page__actions">
            <GreenButton
              type="submit"
              disabled={isSubmitting}
              text={isSubmitting ? 'Sending...' : 'Send Message'}
            />
          </div>
        </form>

        <div className="contact-page__content">
          <div className="contact-page__info-list">
            <div className="contact-page__info-item">
              <span className="contact-page__info-icon"><Icon name="mail" size={18} /></span>
              <div>
                <strong>Email</strong>
                <p><a href="mailto:lalitpureyecenter@gmail.com">lalitpureyecenter@gmail.com</a></p>
              </div>
            </div>
            <div className="contact-page__info-item">
              <span className="contact-page__info-icon"><Icon name="phone" size={18} /></span>
              <div>
                <strong>Phone</strong>
                <p>
                  <a href="tel:+9779808231185">+977 980-8231185</a>
                  {', '}
                  <a href="tel:+9779803722928">+977 980-3722928</a>
                </p>
              </div>
            </div>
            <div className="contact-page__info-item">
              <span className="contact-page__info-icon"><Icon name="message" size={18} /></span>
              <div>
                <strong>WhatsApp</strong>
                <p><a href="https://wa.me/9779803722928" target="_blank" rel="noreferrer">+977 980-3722928</a></p>
              </div>
            </div>
            <div className="contact-page__info-item">
              <span className="contact-page__info-icon"><Icon name="clock" size={18} /></span>
              <div>
                <strong>Support Hours</strong>
                <p>Sun – Fri, 9:15 AM to 7:40 PM</p>
              </div>
            </div>
            <div className="contact-page__info-item">
              <span className="contact-page__info-icon"><Icon name="map-pin" size={18} /></span>
              <div>
                <strong>Store Location</strong>
                <p>Jawalakhel, Lalitpur</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactPage;
